import Page from "../../components/Page";


export default function Contact() {
  return (
    <Page title="Contact">
      <p>EARTHSAVE BALTIMORE</p>
      <p>Organizer: Don Robertson</p>
      <p>
        Email Earthsave Baltimore at Baltimore@Earthsave.org, call us at
        410-252-3043, or write us at 517 Talbott Ave., Lutherville, MD, 21093.
        Website is
      </p>
      <br />
      <p>EARTHSAVE INTERNATIONAL</p>
      <p>Board President: Jeff Nelson</p>
      <p>20555 Devonshire St., Ste. 105,</p>
      <p>Chatsworth, CA 91311,</p>
      <br />
      <a href="http://www.earthsave.org/" target="_blank" rel="noreferrer">
        http://www.earthsave.org/
      </a>
      <br />
      <br />
      <p>EARTHSAVE CHAPTERS AND AFFILIATES</p>
      <br />
      <p>Canada</p>
      <p>Vancouver: 2150 Maple Street, Vancouver, BC V6J 3T3 CANADA</p>
      <p>Phone: (604) 731-5885</p>
      <p>FAX: 604-731-5805</p>
      <span>Email</span>
      <a href="mailto: office@earthsave.ca">office@earthsave.ca</a>
      <p>Website:</p>
      <br />
      <p>Colorado</p>
      <p>Dr. Connie Sanchez N.D.</p>
      <p>
        Center For Health, 3190 S. Wadsworth Blvd., Ste 301, Lakewood, CO 80227
      </p>
      <p>Phone: (720) 206-4440</p>
      <span>Email</span>
      <a href="mailto: colorado@earthsave.org">colorado@earthsave.org</a>

      <p>Website:</p>
      <br />
      <p>Florida</p>
      <p>Miami: Jeff Tucker</p>
      <p>PO Box 160191 Miami, FL 33116-0191</p>
      <p>Phone: (305) 228-1116</p>
      <span>Email</span>
      <a href="mailto: miami@earthsave.org">miami@earthsave.org</a>

      <p>Website:</p>
      <br />
      <p>Florida</p>
      <p>Ocala: Art Konstantino</p>
      <p>P.O. Box 670, Williston, FL 32696</p>
      <p> Phone: (352) 528-5287</p>
      <span>Email</span>
      <a href="mailto: ocala@earthsave.org">ocala@earthsave.org</a>

      <p>Website:</p>
      <br />
      <p>Illinois</p>
      <p>Chicago: 2417 W Homer St, Chicago, IL 60647</p>
      <p>Phone: (312) 924-1801</p>
      <p>Website:</p>
      <br />
      <p>Kentucky</p>
      <p>Lexington:</p>
      <p>Phone: (859) 266-9990</p>
      <span>Email</span>
      <a href="mailto: lexington@earthsave.org">lexington@earthsave.org</a>
      <br />
      <br />
      <p>Kentucky</p>
      <p>Louisville: PO Box 4397, Louisville, KY 40202</p>
      <p>Phone: (502) 569-1876</p>
      <span>Email</span>
      <a href="louisville@earthsave.org">louisville@earthsave.org</a>

      <p>Website:</p>
      <br />
      <p>Minnesota</p>
      <p>Twin Cities</p>
      <p>Phone: (952) 930-1205</p>
      <p>Website:</p>
      <span>Email</span>
      <a href="twincities@earthsave.org">twincities@earthsave.org</a>
      <br />
      <br />
      <p> New York</p>
      <p>New York City/Long Island: PO Box 96, New York, NY 10108</p>
      <p>Phone: (718) 459-7503</p>
      <span>Email</span>
      <a href="nyc@earthsave.org">nyc@earthsave.org</a>

      <p>Website:</p>
      <br />
      <p>New York</p>
      <p>Suffolk</p>
      <span>Email</span>
      <a href="centralsuffolk@earthsave.org">centralsuffolk@earthsave.org</a>
      <br />
      <br />
      <p>Ohio</p>
      <p>Cincinnati: John Mooter</p>
      <p>PO Box 3125, Cincinnati, OH 45201-3125</p>
      <p>Phone: (513) 929-2500</p>
      <span>Email</span>
      <a href="cincinnati@earthsave.org">cincinnati@earthsave.org</a>

      <p>Website: </p>
      <br />
      <p>Utad</p>
      <p>Salt Lake City: Jennifer Russell-Fenus</p>
      <span>Email</span>
      <a href="slc@earthsave.org">slc@earthsave.org</a>
    </Page>
  );
}
